import { render, staticRenderFns } from "./HistoryRecord97.vue?vue&type=template&id=4a2ed48b&scoped=true"
import script from "./HistoryRecord97.vue?vue&type=script&lang=js"
export * from "./HistoryRecord97.vue?vue&type=script&lang=js"
import style0 from "./HistoryRecord97.vue?vue&type=style&index=0&id=4a2ed48b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2ed48b",
  null
  
)

export default component.exports